import * as TYPES from '../types';
import { COMMON, REDUX_CONSTANT } from '../../constants/index';
import {
    mergeServerConfigIntoLocalConfig,
    saveServerConfigObjectToLocal
} from '../../helpers/configHelper';
import { config } from '../../config';
import configInstance from '../../configSingleton';

const initialState = {
    initializing: false,
    initialized: false,
    idToken: null,
    isLoading: false,
    state: REDUX_CONSTANT.AUTH.STATE.UNAUTHENTICATED,
    vendorRoleInfo: {},
    isVendorRoleFromServer: false,
    configValue: config,
    configHashError: false,
    configValueError: false,
    permissionError: false,
    vendorInfoError: false,
    isVendorInfoUpdatedFromServer: false
};

export default function authenticationReducer(state = initialState, action) {
    switch (action.type) {
        case REDUX_CONSTANT.AUTH.STATE.INITIALIZING:
            return {
                ...state,
                initializing: true,
                initialized: false,
                isLoading: false
            };
        case REDUX_CONSTANT.AUTH.STATE.INITIALIZED:
            return {
                ...state,
                initializing: false,
                initialized: true,
                isLoading: false
            };
        case REDUX_CONSTANT.AUTH.STATE.ACQUIRED_ID_TOKEN_SUCCESS:
            return {
                ...state,
                idToken: action.payload,
                isLoading: false
            };
        case REDUX_CONSTANT.AUTH.STATE.LOGIN_SUCCESS:
            return {
                ...state,
                isLoading: false,
                account: action.payload && action.payload.account,
                vendorAADData:
                    action.payload?.account?.idTokenClaims?.roles?.length > 0
                        ? action.payload.account.idTokenClaims.roles
                        : []
            };
        case REDUX_CONSTANT.AUTH.STATE.LOGIN_ERROR:
        case REDUX_CONSTANT.AUTH.STATE.ACQUIRED_ID_TOKEN_ERROR:
        case REDUX_CONSTANT.AUTH.STATE.LOGOUT_SUCCESS:
            return {
                ...state,
                idToken: null,
                account: null
            };
        case REDUX_CONSTANT.AUTH.STATE.AUTHENTICATED_STATE_CHANGED:
            return {
                ...state,
                state: action.payload,
                isLoading: false
            };
        case REDUX_CONSTANT.AUTH.UPDATE_ACQUIRED_VENDOR_ROLE:
            return {
                ...state,
                vendorId: action.payload,
                isLoading: false
            };
        case REDUX_CONSTANT.GET_VENDOR_INFORMATION:
            return {
                ...state,
                vendorInfo: action.payload,
                vendorName: action.payload?.vendorName,
                vendorIdfromInfo: action.payload?.vendorId,
                isVendorInfoUpdatedFromServer: true,
                isLoading: false,
                vendorInfoError: false
            };

        case REDUX_CONSTANT.GET_PERMISSION_BASEDON_ROLES:
            return {
                ...state,
                permissionsForRole: action.payload,
                isLoading: false
            };

        case REDUX_CONSTANT.GET_CONFIGURATION_VALUE:
            let mergedConfig = null;
            if (action.payload) {
                mergedConfig = mergeServerConfigIntoLocalConfig(action.payload);
            }
            if (!action.isFromCache) {
                saveServerConfigObjectToLocal(action.payload);
            }

            configInstance.updateConfig(mergedConfig ?? state.configValue);

            return {
                ...state,
                configValue: mergedConfig ?? state.configValue,
                configError: null,
                configValueError: false
            };

        case REDUX_CONSTANT.ROLES_PERMISSION_INFORMATION:
            return {
                ...state,
                isLoading: false,
                vendorRoleInfo: action.payload,
                isVendorRoleFromServer: true,
                VendorData: getVendorDataFromRoles(action.payload?.userRoles),
                vendorId: updateDefaultVendorId(
                    action.payload?.userRoles,
                    state.vendorId
                ),
                permissionError: false
            };

        case REDUX_CONSTANT.PLATFORM_USER_LOGIN:
            return {
                ...state,
                permissionsInfoFromEmail: action.payload,
                isLoading: false
            };

        case REDUX_CONSTANT.UPDATE_ROLES_DATA:
            return {
                ...state,
                // VendorData: action.payload,
                isLoading: false
            };

        case REDUX_CONSTANT.UPDATE_VENDOR_INFO_DATA:
            return {
                ...state,
                isVendorInfoUpdatedFromServer: action.payload,
                isLoading: false
            };
        case REDUX_CONSTANT.RESET_VENDOR_DATA:
            return {
                ...state,
                isVendorRoleFromServer: false,
                isVendorInfoUpdatedFromServer: false,
                vendorRoleInfo: {}
            };

        case REDUX_CONSTANT.LOGOUT_RESET:
            state = initialState;
            return {
                ...state
            };

        case REDUX_CONSTANT.GET_HASH_VALUE:
            return {
                ...state,
                configHashError: false,
                isLoading: false
            };

        case TYPES.ERROR:
            const newState = {
                ...state,
                isLoading: false,
                vendorInfo:
                    action.payload.title ==
                    REDUX_CONSTANT.GET_VENDOR_INFORMATION
                        ? action.payload.msg
                        : state.vendorInfo,
                permissionsInfoFromEmail:
                    action.payload.title == REDUX_CONSTANT.PLATFORM_USER_LOGIN
                        ? action.payload.msg
                        : state.permissionsInfoFromEmail,
                configHashError:
                    action.payload.title == REDUX_CONSTANT.GET_HASH_VALUE
                        ? true
                        : state.configHashError,
                configValueError:
                    action.payload.title ==
                    REDUX_CONSTANT.GET_CONFIGURATION_VALUE
                        ? true
                        : state.configValueError,
                permissionError:
                    action.payload.title ==
                    REDUX_CONSTANT.ROLES_PERMISSION_INFORMATION
                        ? true
                        : state.permissionError,
                vendorInfoError:
                    action.payload.title ==
                    REDUX_CONSTANT.GET_VENDOR_INFORMATION
                        ? true
                        : state.vendorInfoError
            };

            if (
                action.payload.title == REDUX_CONSTANT.GET_CONFIGURATION_VALUE
            ) {
                newState.configValue = initialState.configValue;
            }

            return newState;
        default:
            return { ...state };
    }
}

export const getVendorDataFromRoles = (roles) => {
    return roles?.map((role) => role.vendorId);
};

const updateDefaultVendorId = (roles, vendorIdFromState) => {
    const vendorIds = getVendorDataFromRoles(roles);
    return vendorIds?.includes(COMMON.admin) && !vendorIdFromState
        ? COMMON.admin
        : vendorIdFromState
          ? vendorIdFromState
          : (vendorIds && vendorIds[0]) || null;
};
